import { AxiosResponse } from 'axios';

import { NoticesResponse } from '@/types/notice';
import { api } from '@/services/api/axios/instance';
import { apiBaseURL } from '@/settings/environment';

const baseURL = apiBaseURL().replace('v2', 'v1');

export const noticesApi = {
  getNotices: async (): Promise<NoticesResponse['notices']> => {
    const path = `notices`;

    const response: AxiosResponse<NoticesResponse> = await api.get(path, {
      baseURL,
    });

    return response.data.notices;
  },
};
